import { forwardRef, ReactNode } from 'react';
import { useDesktopTopNav } from '../../../../Experiments/DesktopTopNavExperiment';
import { FloatingContainer, RelativeOffset } from './SuggestionsContainer.styles';

export const SuggestionsContainer = forwardRef<
  HTMLDivElement,
  { children: ReactNode; enabledFilterOffset?: boolean; inline?: boolean }
>(({ children, enabledFilterOffset = true, inline = false }, ref) => {
  const topNavExperiment = useDesktopTopNav();

  return (
    <RelativeOffset
      enabledFilterOffset={enabledFilterOffset}
      topNavExperiment={topNavExperiment}
      inline={inline}
    >
      <FloatingContainer ref={ref} inline={inline}>
        {children}
      </FloatingContainer>
    </RelativeOffset>
  );
});
